module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_dress-aa153bfbf887aaa01d32330e95078f23.svg";